import { AuthInitialState, FeatureName, UserCompanyFeature } from 'store/auth/auth.types'

/** Normalizes onboarding `GET .../features` for Redux (`featuresByCompany`). */
export const featuresResponseToByCompany = (
  features: UserCompanyFeature[]
): AuthInitialState['featuresByCompany'] =>
  features.reduce(
    (acc, feature) => {
      if (!acc[feature.companyId]) acc[feature.companyId] = {}
      acc[feature.companyId][feature.featureName] = feature.enabled
      return acc
    },
    {} as AuthInitialState['featuresByCompany']
  )

export const isCompanyFeatureEnabled = (
  featuresByCompany: AuthInitialState['featuresByCompany'],
  companyId: string | undefined,
  featureName: FeatureName
) => {
  if (!companyId) return false
  return Boolean(featuresByCompany?.[companyId]?.[featureName])
}
